// ============================================
// src/config/emailjs.config.js
// ============================================

import emailjs from '@emailjs/browser';

// Initialize EmailJS with your User ID
export const initEmailJS = () => {
  const userId = process.env.REACT_APP_EMAILJS_USER_ID || 'YOUR_EMAILJS_USER_ID';
  emailjs.init(userId);
};

export const emailConfig = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'YOUR_SERVICE_ID',
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'YOUR_TEMPLATE_ID'
};